module.exports = __webpack_public_path__ + "img/13-03.befa9090.png";